export class Careers {

  /**
   * Constructor.
   */
  constructor() {
    this.searchForm = document.getElementById("careers-search-form");
    this.careerRows = document.querySelectorAll(".career-row");
    this.textSearch = document.getElementById("career-text-search");
    this.locationSearch = document.getElementById("career-location-search");

    // Check if team member offset is defined.
    this.setEventListeners();
  }

  /**
   * Set all of our event listeners.
   */
  setEventListeners() {
    const _self = this;

    if (_self.searchForm !== null) {
      _self.searchForm.addEventListener("submit", function (e) {
        e.preventDefault();
      });
    }

    if (_self.textSearch !== null) {
      _self.textSearch.addEventListener("keyup", function (e) {
        e.preventDefault();
        _self.filterCareersByText();
      });
    }

    if (_self.locationSearch !== null) {
      _self.locationSearch.addEventListener("change", function (e) {
        e.preventDefault();
        _self.filterCareersByLocation();
      });
    }
  }

  /**
   * Filter careers by text.
   */
  filterCareersByText() {
    const _self = this;

    if (_self.textSearch !== null && _self.careerRows !== null) {
      let textValue = _self.textSearch.value;

      for (let i = 0; i < _self.careerRows.length; i++) {
        if (textValue === "") {
          _self.careerRows[i].classList.remove("d-none-career-text");
          continue;
        }

        let careerTitle = _self.careerRows[i].dataset.careerTitle;

        if (careerTitle === undefined) {
          continue;
        }

        if (careerTitle.toLowerCase().includes(textValue.toLowerCase())) {
          _self.careerRows[i].classList.remove("d-none-career-text");
        } else {
          _self.careerRows[i].classList.add("d-none-career-text");
        }

        console.log(careerTitle);
        console.log(textValue);
        console.log(careerTitle.includes(textValue));
        console.log("---");
      }
    }
  }

  /**
   * Filter by location.
   */
  filterCareersByLocation() {
    const _self = this;

    if (_self.locationSearch !== null && _self.careerRows !== null) {
      let locationValue = _self.locationSearch.value;

      for (let i = 0; i < _self.careerRows.length; i++) {
        if (locationValue === "") {
          // Remove our class of d-none-careers-location
          _self.careerRows[i].classList.remove("d-none-careers-location");
          continue;
        }

        let careerLocation = _self.careerRows[i].dataset.careerLocation;

        if (careerLocation === undefined || careerLocation === "") {
          continue;
        }

        if (careerLocation.toLowerCase().includes(locationValue.toLowerCase())) {
          _self.careerRows[i].classList.remove("d-none-careers-location");
        } else {
          _self.careerRows[i].classList.add("d-none-careers-location");
        }
      }
    }
  }
}

const careers = new Careers();